(()=>{
  const DB_NAME='2in1flags-uploads';
  const STORE='images';
  const DB_VERSION=2;
  const META_KEY='2in1flags:design:upload-meta:v1';
  const MAX_EDGE=9000;

  function openDb(){
    return new Promise((resolve,reject)=>{
      const req=indexedDB.open(DB_NAME,DB_VERSION);
      req.onupgradeneeded=()=>{if(!req.result.objectStoreNames.contains(STORE))req.result.createObjectStore(STORE);};
      req.onsuccess=()=>resolve(req.result);
      req.onerror=()=>reject(req.error);
    });
  }
  async function putImage(record){
    const db=await openDb();
    return new Promise((resolve,reject)=>{
      const tx=db.transaction(STORE,'readwrite');
      tx.objectStore(STORE).put(record,record.id);
      tx.oncomplete=()=>resolve(record);
      tx.onerror=()=>reject(tx.error);
    });
  }
  async function getImage(id){
    if(!id)return null;
    const db=await openDb();
    return new Promise((resolve,reject)=>{
      const req=db.transaction(STORE,'readonly').objectStore(STORE).get(id);
      req.onsuccess=()=>resolve(req.result||null);
      req.onerror=()=>reject(req.error);
    });
  }
  async function listImages(){
    const db=await openDb();
    return new Promise((resolve,reject)=>{
      const req=db.transaction(STORE,'readonly').objectStore(STORE).getAll();
      req.onsuccess=()=>resolve(Array.isArray(req.result)?req.result:[]);
      req.onerror=()=>reject(req.error);
    });
  }
  function uid(){return `up_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`;}
  window.__hfdUploadStore={putImage,getImage,listImages,uid};
  function blankSlot(){return {enabled:false,id:'',dataUrl:'',name:'',scale:100,fitEntire:false,private:false};}
  function isUploadChoice(value){return value==='upload'||value==='my-uploads';}
  function escapeHtml(value){return String(value??'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));}
  const TYPE_OPTIONS=[['country','Countries'],['sports','Sports Teams'],['my-uploads','My Uploads'],['upload','Uploads'],['text','Text']];
  function ensureTypeOptions(select){
    if(!select)return;
    const current=select.value;
    TYPE_OPTIONS.forEach(([value,label])=>{
      let opt=[...select.options].find(option=>option.value===value);
      if(!opt){opt=document.createElement('option');opt.value=value;select.appendChild(opt);}
      opt.textContent=label;
    });
    TYPE_OPTIONS.forEach(([value])=>{
      const opt=[...select.options].find(option=>option.value===value);
      if(opt)select.appendChild(opt);
    });
    if(TYPE_OPTIONS.some(([value])=>value===current))select.value=current;
  }

  function compressFile(file){
    return new Promise((resolve,reject)=>{
      const img=new Image();
      const objectUrl=URL.createObjectURL(file);
      img.onload=()=>{
        const scale=Math.min(1,MAX_EDGE/Math.max(img.naturalWidth||1,img.naturalHeight||1));
        const w=Math.max(1,Math.round((img.naturalWidth||1)*scale));
        const h=Math.max(1,Math.round((img.naturalHeight||1)*scale));
        const canvas=document.createElement('canvas');
        canvas.width=w;canvas.height=h;
        const ctx=canvas.getContext('2d');
        ctx.drawImage(img,0,0,w,h);
        const keepPng=/png/i.test(file.type);
        const dataUrl=keepPng?canvas.toDataURL('image/png'):canvas.toDataURL('image/jpeg',0.92);
        URL.revokeObjectURL(objectUrl);
        resolve({dataUrl,width:w,height:h});
      };
      img.onerror=()=>{URL.revokeObjectURL(objectUrl);reject(new Error('Could not read image'));};
      img.src=objectUrl;
    });
  }

  // Share-link upload slots point at a file with `imageUrl` (not a separate logo field).
  // Only this shop's own file storage is fetched. Query strings such as `?v=` are kept.
  const SHOP_FILE_PREFIX='/s/files/1/1060/5084/7062/';
  const STORE_FILE_PREFIX='/cdn/shop/files/';
  const MAX_STORE_IMAGE_BYTES=20*1024*1024;
  function storeImageUrl(value){
    let url;
    try{url=new URL(String(value??'').trim());}catch(_){return '';}
    if(url.protocol!=='https:'||url.username||url.password)return '';
    const rawPath=url.pathname;
    if(/%2e|%2f|%5c|\\|%00/i.test(rawPath))return '';
    let path=rawPath;
    try{path=decodeURIComponent(rawPath);}catch(_){return '';}
    if(path.includes('\\')||path.includes('\0')||path.split('/').some(seg=>seg==='..'||seg==='.'))return '';
    const lowered=path.toLowerCase();
    const host=url.hostname;
    const shopFile=host==='cdn.shopify.com'&&lowered.startsWith(SHOP_FILE_PREFIX);
    const storeFile=(host==='2in1flags.com'||host==='www.2in1flags.com')&&lowered.startsWith(STORE_FILE_PREFIX);
    return shopFile||storeFile?url.href:'';
  }
  function readBlob(blob){
    return new Promise((resolve,reject)=>{
      const reader=new FileReader();
      reader.onload=()=>resolve(reader.result);
      reader.onerror=()=>reject(reader.error||new Error('Could not read image'));
      reader.readAsDataURL(blob);
    });
  }
  const storeImageLoads=new Map();
  function storeImageDataUrl(imageUrl){
    const href=storeImageUrl(imageUrl);
    if(!href)return Promise.resolve('');
    const cached=storeImageLoads.get(href);
    if(cached)return cached;
    const pending=(async()=>{
      const response=await fetch(href,{mode:'cors',credentials:'omit'});
      if(!response.ok||!storeImageUrl(response.url))return '';
      const blob=await response.blob();
      if(!blob||blob.size>MAX_STORE_IMAGE_BYTES||!/^image\//i.test(blob.type))return '';
      const dataUrl=await readBlob(blob);
      return typeof dataUrl==='string'&&dataUrl.startsWith('data:image/')?dataUrl:'';
    })();
    storeImageLoads.set(href,pending);
    return pending.then(dataUrl=>{
      if(!dataUrl)storeImageLoads.delete(href);
      return dataUrl;
    },error=>{
      storeImageLoads.delete(href);
      throw error;
    });
  }
  window.__hfdStoreImageUrl=storeImageUrl;

  function initUpload(){
    const root=document.querySelector('[data-hfd]');
    if(!root||root.dataset.uploadReady)return;
    root.dataset.uploadReady='1';

    const style=document.createElement('style');
    style.textContent=`
      [data-hfd] .hfd__upload-controls{min-height:44px;border-left:1px solid #e4eaf0;background:#fff;display:none;align-items:center;padding:0 8px;min-width:0;width:100%}
      [data-hfd] .hfd__upload-controls.is-active{display:flex}
      [data-hfd] .hfd__upload-button{display:inline-flex;align-items:center;justify-content:center;width:100%;height:32px;border:1px solid #c8d6e5;border-radius:6px;background:#f8fbff;color:#0a1b43;font:inherit;font-size:1.2rem;font-weight:700;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      [data-hfd] .hfd__upload-button:hover{border-color:#087df5;color:#087df5}
      [data-hfd] .hfd__upload-button input{display:none}
      [data-hfd] .hfd__upload-privacy{grid-column:1/-1;grid-row:3;display:none;align-items:center;gap:10px;padding:8px 10px;border-top:1px solid #e4eaf0;background:#f8fbff}
      [data-hfd] .hfd__upload-privacy.is-active{display:flex}
      [data-hfd] .hfd__private-btn{flex:0 0 auto;height:32px;padding:0 12px;border:1px solid #c8d6e5;border-radius:6px;background:#fff;color:#0a1b43;font:inherit;font-size:1.2rem;font-weight:800;cursor:pointer}
      [data-hfd] .hfd__private-btn:hover{border-color:#087df5;color:#087df5}
      [data-hfd] .hfd__private-btn.is-active{background:#0a1b43;color:#fff;border-color:#0a1b43}
      [data-hfd] .hfd__upload-note{margin:0;font-size:1.15rem;line-height:1.35;font-weight:600;color:#506078}
      [data-hfd] .hfd__upload-quality{margin:0 0 0 auto;font-size:1.15rem;line-height:1.35;font-weight:700;color:#087df5;text-align:right}
      @media(max-width:640px){
        [data-hfd] .hfd__upload-quality{flex:1 0 100%;margin:0;text-align:left}
      }
      [data-hfd] .hfd__select-row.is-disabled .hfd__upload-controls,[data-hfd] .hfd__select-row.is-disabled .hfd__upload-privacy{pointer-events:none;opacity:.55;background:#f3f5f7}
      @media(max-width:640px){
        [data-hfd] .hfd__upload-privacy{grid-row:4;flex-wrap:wrap}
      }
    `;
    document.head.appendChild(style);

    const currentSide=()=>root.querySelector('[data-side].is-active')?.dataset.side||'front';
    const sideOf=el=>window.hfdUi?.of(el)||currentSide();
    const indexInSide=(el,selector)=>{
      const pane=el.closest('[data-hfd-side]');
      return pane?[...pane.querySelectorAll(selector)].indexOf(el.closest(selector)||el):-1;
    };
    const typeSelects=[...root.querySelectorAll('[data-selection-type]')];
    const rows=[...root.querySelectorAll('[data-select-row]')];
    const state={front:Array.from({length:4},blankSlot),back:Array.from({length:4},blankSlot)};
    const controls={front:[],back:[]};
    const publish=()=>{
      window.__hfdUploadState=state;
      try{
        localStorage.setItem(META_KEY,JSON.stringify({
          front:state.front.map(s=>({enabled:!!s.enabled,id:s.id,name:s.name,scale:s.scale,fitEntire:!!s.fitEntire,private:!!s.private})),
          back:state.back.map(s=>({enabled:!!s.enabled,id:s.id,name:s.name,scale:s.scale,fitEntire:!!s.fitEntire,private:!!s.private}))
        }));
      }catch(_){ }
    };
    publish();

    function libraryNameKey(name){
      const value=String(name||'').trim().toLowerCase();
      if(!value||value==='custom image')return '';
      return `name:${value}`;
    }
    function libraryUrlKey(dataUrl){
      const url=String(dataUrl||'');
      if(!url)return '';
      return `url:${url.length}:${url.slice(0,96)}:${url.slice(-48)}`;
    }

    async function libraryList(){
      const byId=new Map();
      const aliases=new Map();
      const byKey=new Map();
      const add=item=>{
        if(!item?.id||!item.dataUrl)return;
        const id=String(item.id);
        const rec={id,name:item.name||'Custom Image',dataUrl:item.dataUrl,private:!!item.private};
        const existing=byId.get(id);
        if(existing){
          if(rec.dataUrl.length>existing.dataUrl.length)existing.dataUrl=rec.dataUrl;
          if(rec.name&&rec.name!=='Custom Image')existing.name=rec.name;
          if(rec.private)existing.private=true;
          return;
        }
        const keys=[libraryUrlKey(rec.dataUrl),libraryNameKey(rec.name)].filter(Boolean);
        const canonId=keys.map(key=>byKey.get(key)).find(Boolean);
        if(canonId){
          const canon=byId.get(canonId);
          aliases.set(id,canonId);
          if(rec.dataUrl.length>canon.dataUrl.length)canon.dataUrl=rec.dataUrl;
          if(rec.name&&rec.name!=='Custom Image')canon.name=rec.name;
          if(rec.private)canon.private=true;
          return;
        }
        byId.set(id,rec);
        keys.forEach(key=>byKey.set(key,id));
      };
      try{
        const parsed=JSON.parse(document.getElementById('hfd-account-uploads')?.textContent||'null');
        (Array.isArray(parsed)?parsed:[]).forEach(add);
      }catch(_){}
      try{(await listImages()).forEach(add);}catch(_){}
      ['front','back'].forEach(sideName=>{(state[sideName]||[]).forEach(add);});
      window.__hfdUploadLibrary={
        get(value){
          const id=String(value||'');
          return byId.get(aliases.get(id)||id)||null;
        }
      };
      window.__hfdUploadAliases=aliases;
      return [...byId.values()].sort((a,b)=>String(a.name||'').localeCompare(String(b.name||''),'en',{sensitivity:'base'}));
    }

    async function fillLibrarySelect(select,preferredId){
      if(!select)return;
      const items=await libraryList();
      const aliases=window.__hfdUploadAliases;
      const old=aliases?.get(String(preferredId||select.value||''))||preferredId||select.value;
      if(!items.length){
        select.innerHTML='<option value="">No saved uploads yet</option>';
        return;
      }
      select.innerHTML=items.map(item=>`<option value="${escapeHtml(item.id)}">${escapeHtml(item.name||'Custom Image')}</option>`).join('');
      if(old&&[...select.options].some(option=>option.value===old))select.value=old;
    }

    async function applyLibraryChoice(side,index,uploadId){
      const rec=window.__hfdUploadLibrary?.get?.(String(uploadId||''));
      const slot=state[side]?.[index];
      if(!slot)return;
      if(!rec){
        slot.enabled=true;
        return;
      }
      slot.enabled=true;
      slot.id=rec.id;
      slot.dataUrl=rec.dataUrl;
      slot.name=rec.name||slot.name||'Custom Image';
      slot.private=!!rec.private;
      try{await putImage({id:slot.id,dataUrl:slot.dataUrl,name:slot.name,updatedAt:Date.now()});}catch(_){}
    }

    typeSelects.forEach(select=>{
      const side=sideOf(select);
      const index=indexInSide(select,'[data-selection-type]');
      const row=select.closest('[data-select-row]');
      if(index<0||!row)return;
      ensureTypeOptions(select);

      const box=document.createElement('div');
      box.className='hfd__upload-controls';
      box.dataset.uploadControls=String(index);
      const label=document.createElement('label');
      label.className='hfd__upload-button';
      const text=document.createTextNode('Upload Image');
      const file=document.createElement('input');
      file.type='file';
      file.accept='image/png,image/jpeg,image/webp,image/gif';
      file.setAttribute('aria-label',`Upload image for Flag ${index+1}`);
      label.append(text,file);
      box.append(label);
      const privacy=document.createElement('div');
      privacy.className='hfd__upload-privacy';
      const privateBtn=document.createElement('button');
      privateBtn.type='button';
      privateBtn.className='hfd__private-btn';
      privateBtn.textContent='Private';
      privateBtn.setAttribute('aria-pressed','false');
      privateBtn.setAttribute('aria-label',`Make Flag ${index+1} private`);
      const note=document.createElement('p');
      note.className='hfd__upload-note';
      note.textContent='Designs using this image can be shown to others.';
      const quality=document.createElement('p');
      quality.className='hfd__upload-quality';
      quality.textContent='Tip: upload the highest-quality image you have for the sharpest print.';
      privacy.append(privateBtn,note,quality);
      row.append(box,privacy);
      controls[side][index]={box,file,label,text,privacy,privateBtn,note,row,select};

      privateBtn.addEventListener('click',e=>{
        e.preventDefault();
        e.stopPropagation();
        const s=state[side][index];
        s.private=!s.private;
        apply();broadcast();
      });

      file.addEventListener('change',async ()=>{
        const selected=file.files?.[0];
        file.value='';
        if(!selected||!selected.type.startsWith('image/'))return;
        try{
          const compressed=await compressFile(selected);
          const s=state[side][index];
          s.enabled=true;
          s.id=s.id||uid();
          s.dataUrl=compressed.dataUrl;
          s.name=selected.name;
          await putImage({id:s.id,dataUrl:s.dataUrl,name:s.name,updatedAt:Date.now()});
          await libraryList();
          apply();broadcast();
        }catch(error){
          console.warn('2in1Flags upload failed',error);
        }
      });
    });

    function broadcast(){
      publish();
      document.dispatchEvent(new CustomEvent('flag:upload-state',{detail:JSON.parse(JSON.stringify(state))}));
    }

    function apply(){
      ['front','back'].forEach(side=>{
        const pane=window.hfdUi?.pane(root,side);
        const sideRows=pane?.rows||[];
        const sideLayers=pane?.layers||[];
        const sideTypes=pane?.types||[];
        sideRows.forEach((row,index)=>{
          const s=state[side][index];
          if(!s||!controls[side][index])return;
          const typeVal=sideTypes[index]?.value;
          const uploadMode=typeVal==='upload';
          const libraryMode=typeVal==='my-uploads';
          const textMode=typeVal==='text';
          const enabled=s.enabled||uploadMode||libraryMode;
          s.enabled=enabled;
          const searchBox=row.querySelector('.hfd__search-select');
          const nativeFlag=row.querySelector('[data-flag-selection]');
          controls[side][index].box.classList.toggle('is-active',uploadMode);
          controls[side][index].privacy.classList.toggle('is-active',enabled);
          if(searchBox)searchBox.style.display=(uploadMode||textMode)?'none':'';
          if(nativeFlag&&!nativeFlag.classList.contains('hfd__native-search-select'))nativeFlag.style.display=(uploadMode||textMode)?'none':'';
          if(enabled){
            if(sideTypes[index]&&!isUploadChoice(sideTypes[index].value))sideTypes[index].value='upload';
            controls[side][index].text.textContent=s.dataUrl?'Change Image':'Upload Image';
            controls[side][index].privateBtn.classList.toggle('is-active',!!s.private);
            controls[side][index].privateBtn.setAttribute('aria-pressed',s.private?'true':'false');
            controls[side][index].note.textContent=s.private?'Designs using this image stay private.':'Designs using this image can be shown to others.';
            if(s.dataUrl){
              s.id=s.id||uid();
              const img=sideLayers[index]?.querySelector('img');
              if(img&&img.src!==s.dataUrl){
                img.src=s.dataUrl;
                img.style.objectFit='contain';
              }
              row.dataset.libraryImage=s.dataUrl;
              row.dataset.librarySports='0';
              row.dataset.uploadId=s.id||'';
            }
          }else{
            row.dataset.uploadId='';
          }
        });
      });
      publish();
    }

    async function restoreFromMeta(){
      let meta=null;
      try{meta=JSON.parse(localStorage.getItem(META_KEY)||'null');}catch(_){meta=null;}
      if(!meta)return;
      for(const side of ['front','back']){
        for(let i=0;i<4;i++){
          const saved=meta[side]?.[i];
          if(!saved?.enabled||!saved.id)continue;
          const slot=state[side][i];
          slot.enabled=true;
          slot.id=saved.id;
          slot.name=saved.name||'';
          slot.scale=Number(saved.scale||100);
          slot.fitEntire=!!saved.fitEntire;
          slot.private=!!saved.private;
          if(slot.dataUrl)continue;
          try{
            const stored=await getImage(saved.id);
            // A share link may have filled this slot while the local record was loading.
            if(slot.dataUrl)continue;
            if(stored?.dataUrl){
              slot.dataUrl=stored.dataUrl;
              slot.name=stored.name||slot.name;
            }
          }catch(error){console.warn('2in1Flags upload restore failed',error);}
        }
      }
      apply();broadcast();
    }

    async function hydrateSide(side,items){
      if(!Array.isArray(items))return;
      for(let i=0;i<Math.min(4,items.length);i++){
        const item=items[i];
        if(!item||(item.type!=='upload'&&item.type!=='my-uploads'&&!item.uploadId)){
          if(!state[side][i]?.dataUrl)state[side][i]=blankSlot();
          continue;
        }
        const slot=state[side][i];
        slot.enabled=true;
        slot.id=item.uploadId||item.id||slot.id||uid();
        slot.name=item.name||slot.name||'';
        slot.scale=Number(item.scale||slot.scale||100);
        slot.fitEntire=!!item.fitEntire;
        slot.private=!!item.private;
        if(item.imageUrl&&String(item.imageUrl).startsWith('data:'))slot.dataUrl=item.imageUrl;
        // A shared upload names the file in imageUrl. That file replaces any image this browser already stored for the slot.
        const sharedUrl=storeImageUrl(item.imageUrl);
        if(sharedUrl){
          slot.dataUrl='';
          try{
            const shared=await storeImageDataUrl(item.imageUrl);
            if(shared)slot.dataUrl=shared;
          }catch(error){console.warn('2in1Flags shared image fetch failed',error);}
        }
        if(!slot.dataUrl&&!sharedUrl&&slot.id){
          try{
            const stored=await getImage(slot.id);
            if(stored?.dataUrl){
              slot.dataUrl=stored.dataUrl;
              slot.name=stored.name||slot.name;
            }
          }catch(error){console.warn('2in1Flags upload restore failed',error);}
        }
        if(slot.dataUrl)await putImage({id:slot.id,dataUrl:slot.dataUrl,name:slot.name,updatedAt:Date.now()});
      }
    }

    root.addEventListener('change',e=>{
      if(window.__hfdApplyingLibrary)return;
      const typeSelect=e.target.closest?.('[data-selection-type]');
      const flagSelect=e.target.closest?.('[data-flag-selection]');
      if(typeSelect){
        const side=sideOf(typeSelect);
        const index=indexInSide(typeSelect,'[data-selection-type]');
        if(index<0||!state[side]?.[index])return;
        if(isUploadChoice(typeSelect.value)){
          e.stopImmediatePropagation();
          state[side][index].enabled=true;
          const row=typeSelect.closest('[data-select-row]');
          const flag=row?.querySelector('[data-flag-selection]');
          if(typeSelect.value==='my-uploads'){
            fillLibrarySelect(flag,state[side][index].id).then(()=>applyLibraryChoice(side,index,flag?.value)).then(()=>{apply();broadcast();});
          }else{
            requestAnimationFrame(()=>{apply();broadcast();});
          }
        }else{
          state[side][index].enabled=false;
          requestAnimationFrame(()=>{apply();broadcast();});
        }
        return;
      }
      if(!flagSelect)return;
      const row=flagSelect.closest('[data-select-row]');
      const type=row?.querySelector('[data-selection-type]');
      if(type?.value!=='my-uploads')return;
      const side=sideOf(flagSelect);
      const index=indexInSide(flagSelect,'[data-flag-selection]');
      if(index<0||!state[side]?.[index])return;
      applyLibraryChoice(side,index,flagSelect.value).then(()=>{apply();broadcast();});
    },true);

    root.addEventListener('click',e=>{
      const reset=e.target.closest?.('[data-reset-side]');
      if(reset){
        state[reset.dataset.resetSide]=Array.from({length:4},blankSlot);
        setTimeout(()=>{apply();broadcast();},0);
        return;
      }
      if(e.target.closest?.('[data-side]'))return;
      if(e.target.closest?.('[data-count],[data-cross]'))setTimeout(()=>apply(),0);
    });

    document.addEventListener('flag:sides-swapped',()=>{
      const next=state.front;
      state.front=state.back;
      state.back=next;
      publish();
      requestAnimationFrame(()=>{apply();broadcast();});
    });
    document.addEventListener('flag:design-change',()=>requestAnimationFrame(apply));
    document.addEventListener('flag:image-adjust-state',e=>{
      const fit=e.detail?.fit,scale=e.detail?.scale;
      if(!fit||!scale)return;
      ['front','back'].forEach(side=>{
        state[side].forEach((slot,index)=>{
          if(fit[side])slot.fitEntire=!!fit[side][index];
          if(scale[side])slot.scale=Number(scale[side][index]||100);
        });
      });
      publish();
    });
    document.addEventListener('flag:restore-uploads',async e=>{
      const detail=e.detail||{};
      await hydrateSide('front',detail.front);
      await hydrateSide('back',detail.back);
      apply();broadcast();
      document.dispatchEvent(new CustomEvent('flag:uploads-restored'));
    });

    async function restoreFromQuery(){
      const raw=new URLSearchParams(location.search).get('upload');
      if(!raw)return false;
      let item=null;
      try{
        const normalized=raw.replace(/-/g,'+').replace(/_/g,'/');
        const binary=atob(normalized+'='.repeat((4-normalized.length%4)%4));
        const bytes=Uint8Array.from(binary,char=>char.charCodeAt(0));
        item=JSON.parse(new TextDecoder().decode(bytes));
      }catch(_){return false;}
      if(!item?.dataUrl||!String(item.dataUrl).startsWith('data:image/'))return false;
      const slot=state.front[0];
      slot.enabled=true;
      slot.id=item.id||uid();
      slot.name=item.name||'Custom Image';
      slot.dataUrl=item.dataUrl;
      slot.private=!!item.private;
      slot.scale=100;
      slot.fitEntire=false;
      await putImage({id:slot.id,dataUrl:slot.dataUrl,name:slot.name,updatedAt:Date.now()});
      const type=window.hfdUi?.nodes(root,'front','[data-selection-type]')[0]||typeSelects[0];
      if(type){
        type.value='upload';
        type.dispatchEvent(new Event('change',{bubbles:true}));
      }
      apply();broadcast();
      return true;
    }

    window.__hfdUploadStore={putImage,getImage,listImages,uid};
    restoreFromMeta().then(()=>restoreFromQuery()).then(()=>libraryList()).then(()=>{apply();broadcast();});
    setTimeout(()=>{apply();broadcast();},0);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initUpload);else initUpload();
})();
